import { isEmpty, compact } from "lodash";

export default (queryParams) => {
  if (isEmpty(queryParams)) {
    return "";
  }
  const { sort = [], ...rest } = queryParams;
  const sortQueryString = sort.map((string) => `sort=${string}`).join("&");
  const restQueryEntries = Object.entries(rest);
  const unfoldedEntries = restQueryEntries.map(([param, value]) =>
    Array.isArray(value) ? value.map((v) => ({ param, value: v })) : { param, value }
  );
  const restQueryString = unfoldedEntries
    .flat()
    .map(({ param, value }) => `${param}=${encodeURIComponent(value)}`)
    .join("&");
  const queryString = compact([sortQueryString, restQueryString]).join("&");
  return queryString;
};
